import neighborhoodSmartMappingDefinition, {
  recommendedSmartMappingOptions,
} from '../smartMapping/neighborhoodSmartMapping.definition'
import neighborhoodEditCoverageAreaDefinition from './neighborhoodEditCoverageArea.definition'
import neighborhoodFetchDefinition from '../fetch/neighborhoodFetch.definition'
import { MultiPolygon, Polygon } from 'geojson'
import { EditCoverageArea, ItemContentWrapper } from '~/components/editCoverageArea'
import { useCallback } from 'react'
import useAPI from '~/prix/react/hooks/api'
import type { Feature } from 'geojson'
import theme from '~/design'

interface NeighborhoodOrCommunity {
  key: string
  id: number
  name: string
  kind:
    | 'smartMapping'
    | 'deprecated'
    | 'manualDrawing'
    | 'authorityProvided'
    | 'openStreetMapSourced'
  alternativeNames: string[]
  isCommunity: boolean
  coverageArea: Polygon | MultiPolygon
  municipalityId: number
}

const EditCoverageAreaScreen = EditCoverageArea<
  NeighborhoodOrCommunity,
  typeof neighborhoodFetchDefinition.input,
  typeof neighborhoodFetchDefinition.output,
  typeof neighborhoodEditCoverageAreaDefinition.input,
  typeof neighborhoodEditCoverageAreaDefinition.output,
  typeof neighborhoodSmartMappingDefinition.input,
  typeof neighborhoodSmartMappingDefinition.output
>

export default function NeighborhoodEditCoverageAreaScreen() {
  const api = useAPI()
  console.log('NeighborhoodEditCoverageAreaScreen', { api })

  const renderItemContent = useCallback(
    (item: NeighborhoodOrCommunity, onChange: (item: NeighborhoodOrCommunity) => void) => {
      return (
        <ItemContentWrapper>
          <label>
            <input
              type='checkbox'
              checked={item.isCommunity}
              onChange={event => onChange({ ...item, isCommunity: event.target.checked })}
            />{' '}
            Comunidade
          </label>
        </ItemContentWrapper>
      )
    },
    [],
  )

  const getCustomProperty = useCallback(
    (feature: Feature<Polygon | MultiPolygon, NeighborhoodOrCommunity>) => {
      if (feature.properties.isCommunity === true) {
        return {
          fillColor: theme.colors.tertiary,
          strokeColor: theme.colors.tertiary,
        }
      }
      return {
        fillColor: '#ffffff',
        strokeColor: '#ffffff',
      }
    },
    [],
  )

  const renderItemTag = useCallback((item: NeighborhoodOrCommunity) => {
    if (item.isCommunity) {
      return (
        <span
          style={{
            backgroundColor: `${theme.colors.tertiary}22`,
            color: theme.colors.tertiary,
            borderColor: theme.colors.tertiary,
          }}
          className='tag'
        >
          Comunidade
        </span>
      )
    } else {
      return (
        <span
          style={{
            backgroundColor: '#ffffff',
            color: theme.colors.darkGrey,
            borderColor: theme.colors.darkGrey,
          }}
          className='tag'
        >
          Bairro
        </span>
      )
    }
  }, [])

  return (
    <EditCoverageAreaScreen
      editCoverageAreaDefinition={neighborhoodEditCoverageAreaDefinition}
      fetchDefinition={neighborhoodFetchDefinition}
      smartMappingDefinition={neighborhoodSmartMappingDefinition}
      recommendedSmartMappingOptions={recommendedSmartMappingOptions}
      renderItemContent={renderItemContent}
      renderItemTag={renderItemTag}
      getCustomProperty={getCustomProperty}
    />
  )
}
